import React, { useEffect, useState } from "react";
import topVideo from "../assets/video/top_video.mp4";
import phone_icon from "../assets/img/phone.png";
import "../App.css";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate, Link } from "react-router-dom";
import { ReactTyped } from "react-typed";
import choose1 from "../assets/img/c1.png";
import choose2 from "../assets/img/c2.png";
import choose3 from "../assets/img/c3.png";
import choose4 from "../assets/img/c4.png";
import choose5 from "../assets/img/c5.png";
import choose6 from "../assets/img/c6.png";
import postConstructionImage from "../assets/gallery/postconstructionclean/a1.jpg";
import residentialImage from "../assets/gallery/residentialcleaning/a1.jpg";
import commercialImage from "../assets/gallery/commercialclean/a1.jpg";
import airbnbImage from "../assets/gallery/airbnbcleaning/a1.jpg";
import carpetImage from "../assets/gallery/carpetcleaningandfloorcare/a1.jpg";
import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
  const [newsItems, setNewsItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    const elements = document.querySelectorAll(".scroll-reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((el) => observer.observe(el));

    const fetchNews = async () => {
      try {
        const snapshot = await getDocs(collection(db, "news"));
        const items = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setNewsItems(items.slice(0, 3));
      } catch (error) {
        console.error("Failed to fetch news:", error);
      }
    };

    fetchNews();
  }, []);

  return (
    <div>
      <div className="video-container">
        <video
          className="top-video"
          src={topVideo}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        />

        <div className="video-overlay">
          <h1 className="animated-text">
            <span>Welcome to Luxe Sparkle</span>
            <span>Where Clean Meets Care </span>
          </h1>
        </div>
      </div>

      <section className="home_about">
        <div className="about_sub1">
          <h2>
            <span data-aos="fade-up">Our</span> Commitment{" "}
            <span data-aos="fade-up">to</span> Clean Living
          </h2>
          <p>
            Clean living is not a slogan for Luxe Sparkle. It is a
            responsibility delivered through structured systems and accountable
            service.
          </p>
          <p>
            As a New Zealand owned cleaning company based in Auckland, we
            operate with defined processes that support safe, compliant and well
            managed environments. Every site runs through digital job scheduling
            with automated confirmations, documented checklists and recorded
            completion.
          </p>
          <p>
            Health and Safety standards are embedded into our operations,
            including Job Safety Analysis and site induction capability where
            required. Correction requests are addressed within a defined 24 to
            48 hour window. Service delivery follows agreed scope and clear
            communication from start to finish.
          </p>
          <p>
            We use environmentally responsible, people safe products wherever
            suitable. Protecting your workplace, your property and your Whānau
            is part of how we operate.
          </p>
          <p>
            Our commitment is simple.
            <br />
            Deliver what is agreed. Document what is completed. Maintain
            standards that can be verified.
          </p>
          <p>Where Clean Meets Care.</p>
        </div>

        <div className="about_sub1">
          <div className="about_contact">
            <p className="contact-lead">
              Looking for the cleaning service in Auckland?
              <br />
              Contact us now!
            </p>
            <div className="call_btn" data-aos="fade-down">
              <div className="call_inner">
                <div className="call_icon">
                  <img src={phone_icon} alt="Phone" />
                </div>
                <a className="call-button" href="tel:092430470">
                  09 243 0470
                </a>
              </div>
            </div>
          </div>

          <div className="about_faq">
            <ReactTyped
              strings={["Need help?", "Have questions?", "Check our FAQs!"]}
              typeSpeed={50}
              backSpeed={30}
              loop
            />
            <br />
            <Link className="faq-button" to="/FAQs">
              FAQs
            </Link>
          </div>
        </div>
      </section>

      <section className="service_sec">
        <h2 className="h2_service">
          <span data-aos="fade-down">Our</span> Service
        </h2>
        <div className="services-grid">
          {[
            {
              title: "After Builder & Open Home Cleaning",
              desc: "From Construction Dust to Showroom Shine.",
              cta: "Request your post-build quote today.",
              image: postConstructionImage,
            },
            {
              title: "Residential Cleaning",
              desc: "Clean, fresh, and safe for Healthy Homes",
              cta: "Let your home sparkle — the natural way.",
              image: residentialImage,
            },
            {
              title: "Commercial Cleaning",
              desc: "Professional Spaces, Sustainable Solutions",
              cta: "Make a lasting impression.",
              image: commercialImage,
            },
            {
              title: "Airbnb Cleaning",
              desc: "Sustainably Clean — From the Outside In",
              cta: "Schedule your next turnover today!",
              image: airbnbImage,
            },
            {
              title: "Carpet Cleaning",
              desc: "Deep Clean. Fresh Feel.",
              cta: "Book your carpet clean today!",
              image: carpetImage,
            },
          ].map((service, index) => (
            <div className="card_back" key={index} data-aos="fade-up">
              <div className="corner"></div>
              <div
                className="service-card"
                style={{ backgroundImage: `url(${service.image})` }}
              ></div>
              <div className="card_desc">
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <p className="cta">{service.cta}</p>

                <Link
                  to={`/services/${service.title.toLowerCase().replace(/ /g, "-")}`}
                  className="service-btn"
                >
                  Find Out More & Schedule →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="choose_sec">
        <div className="choose_container">
          <h2>
            Why Choose <span>Luxe Sparkle</span>
          </h2>
          <ul className="choose_list">
            {[choose1, choose2, choose3, choose4, choose5, choose6].map(
              (icon, idx) => (
                <li className="scroll-reveal" key={idx} data-aos="zoom-in">
                  <span className="card-icon">
                    <img src={icon} alt={`icon${idx + 1}`} />
                  </span>
                  {
                    [
                      "Structured Service Delivery Every service operates under defined scope, digital scheduling and documented completion.",
                      "Health and Safety Compliance Job Safety Analysis templates, site induction capability and incident reporting processes.",
                      "Background Checked Staff Team members trained under documented Standard Operating Procedures.",
                      "Digital Job Management Automated confirmations, reminders and service tracking through structured systems.",
                      "Correction Accountability Service corrections addressed within a defined 24 to 48 hour window.",
                      "Commercial Consumables and Linen Supply Workplace consumables for commercial sites and linen coordination for Airbnb properties.",
                    ][idx]
                  }
                </li>
              )
            )}
          </ul>
        </div>
      </section>

      <section className="news_section">
        <div className="news_container">
          <h2>
            Latest <span>News</span> & <span>Updates</span>
          </h2>
          <div className="news_grid">
            {newsItems.map((item) => (
              <div className="news_card" key={item.id} data-aos="fade-up">
                <img src={item.image} alt={item.title} className="news_image" />
                <div className="news_content">
                  <h4>{item.title}</h4>
                  {item.date && (
                    <small className="news_date">
                      {item.date.toDate().toLocaleDateString("en-NZ", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </small>
                  )}
                  <p>{item.sub_title}</p>
                  <Link to={`/news/${item.id}`} className="news_link">
                    Read More →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="view_all_btn_sec">
          <button
            className="view_all_text_btn"
            onClick={() => navigate("/news")}
          >
            View All News →
          </button>
        </div>
      </section>

      <section className="booking_area" data-aos="fade-up">
        <div className="booking_container">
          <h2>
            Ready to <span>Make</span>
            <br /> Your <span> Space Sparkle?</span>
          </h2>
          <p>Book your eco-friendly clean with Luxe Sparkle today.</p>
          <Link to="/booking" className="booking_btn" data-aos="fade-right">
            Book Now
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
